import Icon from "./icons/Icon";
import { AUFGABEN } from "../aufgaben";
import "./TaskHeading.css";

/**
 * Was in dieser Runde gesucht wird: Ueberzeile, Icon, Name ("Titel").
 * typ: TITLE | ARTIST | YEAR | ALBUM. text: optionaler Satz darunter.
 * @category spiel
 */
export function TaskHeading({ typ, ueberzeile = "Gesucht wird", text, className }) {
  const aufgabe = AUFGABEN[typ];
  return (
    <div className={["aufgabe", className].filter(Boolean).join(" ")}>
      <span className="ueberzeile gruen">{ueberzeile}</span>
      <h2 className="aufgabe-name">
        <span className="aufgabe-ikon">
          <Icon name={aufgabe?.icon || "titel"} size={26} />
        </span>
        {aufgabe?.name || "…"}
      </h2>
      {text && <p className="aufgabe-text">{text}</p>}
    </div>
  );
}

export default TaskHeading;
